import {
  IconButton,
  InputAdornment,
  Skeleton,
  TextField,
  Tooltip,
  Grid,
  Button,
} from "@mui/material";
import * as React from "react";
import Highlight from "react-highlighter";
import NumberCard from "app/common/NumberCard";
import peopleIcon from "../../../assets/icons/global-icon-guest-black.svg";
import SearchIcon from "../../../assets/icons/global-icon-search-black.svg";
import SearchCloseIcon from "../../../assets/icons/global-icon-black-close.svg";
import Confused from "../../../assets/icons/global-icon-20_Confused.svg";
import AddIcon from "../../../assets/icons/global-icon-add-device-magenta.svg";
import RemoveIcon from "../../../assets/icons/global-icon-remove-line-magenta.svg";
import ShareIcon from "../../../assets/icons/global-icon-share-line-magenta.svg";
import WearableIcon from "../../../assets/icons/global-icon-wearable.svg";
import helpIcon from "../../../assets/icons/global-icon-black-help.svg";
import iconClose from "../../../assets/icons/icon-white-close.svg";

import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/reducers";
import {
  filterLineDelveDetails,
  getLineDelveDetails,
  getPairedLine,
  resetLineDelveDetails,
} from "app/LineDelve/actions";
import { userEmails } from "app/LineDelve/reducers/index.model";
// import { updateSavingName } from "app/common/NumberCard/action";
// import ModalDialog from 'app/common/ModalDialog/ModalDialog'
import { useNavigate } from "react-router-dom";
import { EditIcon, CancelIcon, SaveIcon } from "app/LineDelve/IconList";
import "./lineListDetails.scss";
// import { ComponentsContent } from 'app/common/NumberCard/NumberCardContent'
import appService from "app/service";
import "./lineListDetails.scss";
import { Category } from "app/utils/categories";
import { LineDetails, Lines } from "../reducers/index.model";
import { DecryptString } from "app/utils/crypto";
// import { Lines } from "app/sdk";

interface PropsType {
  onRemoveCB: (data: any) => void;
  assignCB: () => void;
  removeSelfCB: () => void;
  shareLineCB: () => void;
  unpairCB: (data: any) => void;
  deactivateCB: (deviceID: any, id: string) => void;
  onSaveCB: (contactName: string) => void;
}

export default function LineListDetails(props: PropsType): React.ReactElement {
  const {
    assignCB,
    removeSelfCB,
    shareLineCB,
    unpairCB,
    deactivateCB,
    onSaveCB,
  } = props;
  const { onRemoveCB } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const CHARACTER_LIMIT = 100;
  const [contactName, setContactName] = React.useState("");
  const [showSkeleton, setShowSkeleton] = React.useState(false);
  //  const [removeData, setRemoveData] = React.useState<any>(null)
  const [searchInputValue, setSearchInputValue] = React.useState("");
  const [searchOnFocus, setSearchOnFocus] = React.useState(false);
  // const isError = useSelector((state: RootState) => state.numberCard.isError);
  const errorMessage = useSelector((state: RootState) => state.lineDelve.error);
  const selectedLine = useSelector(
    (state: RootState) => state.allLines.selectedLineDetails
  );
  const isPending = useSelector((state: RootState) => state.lineDelve.loading);

  const lineDelveDetails = useSelector(
    (state: RootState) => state.lineDelve.lineDelveDetails
  );
  const primaryDeviceList = useSelector(
    (state: RootState) => state.lineDelve.primaryDevice
  );
  const pairedLines = useSelector(
    (state: RootState) => state.lineDelve.pairedLine
  );

  const editDeviceRef = React.useRef() as React.MutableRefObject<
    HTMLInputElement
  >;

  const lines: LineDetails[] = useSelector((state: RootState) =>
    state.allLines.lineDetailMainObject.filter((item: LineDetails) => {
      return item.id === selectedLine.categoryID;
    })
  );
  let checkIsLineEditable: boolean = false;
  let checkIsShareableLine: boolean = false;
  if (lines.length > 0) {
    const line: Lines[] = lines[0].lines.filter((line: Lines) => {
      return line.msisdn === selectedLine.id;
    });
    if (line.length > 0) {
      checkIsLineEditable = line[0].isEditable;
      checkIsShareableLine = line[0].isShareble;
    }
  }
  const [isEdit, setIsEdit] = React.useState(false);
  const loading = useSelector((state: RootState) => state.numberCard.loading);
  const userMsisdn = DecryptString(sessionStorage.getItem("userMsisdn"));
  const [selectedTooltip, setSelectedTooltip] = React.useState(false);

  const assignActionRef = React.useRef() as React.MutableRefObject<
    HTMLAnchorElement
  >;
  const shareLineRef = React.useRef() as React.MutableRefObject<
    HTMLAnchorElement
  >;

  const handleCloseTooltip = () => {
    setSelectedTooltip(false);
  };

  const handleTooltip = () => {
    setSelectedTooltip(true);
  };

  const [iconsAction, setIconsAction] = React.useState<any>();

  React.useEffect(() => {
    if (selectedLine.id === "") {
      navigate("/");
    } else {
      dispatch(getLineDelveDetails({ id: selectedLine.id }));
      const categoryID = selectedLine.categoryID;
      if (
        categoryID === Category.unAssignedID ||
        categoryID === Category.assignedID
      ) {
        dispatch(getPairedLine({ msisdn: selectedLine.id }));
      }
      setContactName(selectedLine.deviceName);
    }
    document.body.addEventListener("click", handleCloseTooltip);

    return () => {
      dispatch(resetLineDelveDetails());
      document.body.removeEventListener("click", handleCloseTooltip);
    };
  }, []);

  React.useEffect(() => {
    if (isPending) {
      setShowSkeleton(true);
    } else {
      setShowSkeleton(false);
    }
  }, [isPending]);

  React.useEffect(() => {
    setContactName(selectedLine.deviceName);
    setIconsAction(iconActionData);
  }, []);
  const onPencilClick = () => {
    setIsEdit(true);
    setIconsAction((prevState: any) => {
      return {
        ...prevState,
        pencil: { ...prevState.pencil, show: false },
        cancel: { ...prevState.cancel, show: true },
        save: { ...prevState.save, show: false },
      };
    });
    setTimeout(() => {
      editDeviceRef.current.focus();
    }, 500);
  };
  const onSaveClick = () => {
    var updatedContactName;
    setContactName((currentState) => {
      updatedContactName = currentState;
      return currentState;
    });
    setIsEdit(false);
    setIconsAction((prevState: any) => {
      return {
        ...prevState,
        pencil: { ...prevState.pencil, show: true },
        cancel: { ...prevState.cancel, show: false },
        save: { ...prevState.save, show: false },
      };
    });
    onSaveCB(updatedContactName ? updatedContactName : "");
  };

  const onCancelClick = () => {
    setIsEdit(false);
    setContactName(selectedLine.deviceName);
    setIconsAction((prevState: any) => {
      return {
        ...prevState,
        pencil: { ...prevState.pencil, show: true },
        cancel: { ...prevState.cancel, show: false },
        save: { ...prevState.save, show: false },
      };
    });
  };

  React.useEffect(() => {
    iconActionData.pencil.show = checkIsLineEditable;
    // selectedLine?.categoryID === Category.assignedID && true;
    setIconsAction(iconActionData);
  }, [checkIsLineEditable]);

  const iconActionData = {
    pencil: {
      callBack: onPencilClick,
      position: "left",
      toolTipText: "Edit line name",
      show: checkIsLineEditable,
    },
    save: {
      callBack: onSaveClick,
      position: "left",
      toolTipText: "Save line name",
      show: false,
    },
    cancel: {
      callBack: onCancelClick,
      position: "left",
      toolTipText: "Cancel line name",
      show: false,
    },
  };

  const calWidth = () => {
    if (contactName.length > 80) {
      return contactName.length * 10 - 10 + "px";
    } else {
      return 50 + contactName.length * 10 + "px";
    }
  };

  const handleKeyUp = (event: any, ele: any) => {
    if (typeof ele === "string") {
      const targetEle: any = document.querySelector("#" + ele);
      if (event.keyCode === 9) {
        // targetEle.nextSibling.querySelector('span').focus()
      }
      if (event.keyCode === 13) {
        targetEle.click();
      }
    } else {
      if (event.keyCode === 13) {
        ele.current.click();
      }
    }
  };

  const onSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchInputValue(e.target.value);
    if (value && value.length > 1) {
      dispatch(filterLineDelveDetails(value));
    } else {
      if (value.length < 2 && value.length > 0) {
        dispatch(filterLineDelveDetails(""));
      }
    }
  };

  const clearSearchInput = () => {
    setSearchInputValue("");
    dispatch(filterLineDelveDetails(""));
  };

  const onContactInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContactName(e.target.value);
    if (iconsAction.pencil.show === false) {
      if (e.target.value) {
        setIconsAction((prevState: any) => {
          return {
            ...prevState,
            save: { ...prevState.save, show: true },
          };
        });
      } else {
        setIconsAction((prevState: any) => {
          return {
            ...prevState,
            save: { ...prevState.save, show: false },
          };
        });
      }
    }
  };

  const ClearEditInput = () => {
    setContactName("");
    setIconsAction((prevState: any) => {
      return {
        ...prevState,
        save: { ...prevState.save, show: false },
      };
    });
  };

  const searchOnFocusAction = () => {
    setSearchOnFocus(true);
  };

  const OnInputFocus = () => {};

  const isRemoveMyselfShow = () => {
    const msisdn = selectedLine?.id?.substring(1);
    return (
      msisdn !== userMsisdn &&
      (selectedLine.categoryID === Category.lineSharedID ||
        selectedLine.categoryID === Category.assignedID)
    );
  };

  return (
    <React.Fragment>
      <Grid item container rowSpacing={2}>
        <Grid item xs={12} md={7} className="Line-delve">
          {selectedLine.deviceName !== "" && (
            <div className="Name-container" tabIndex={0}>
              {!isEdit && (
                <span className="Line-delve-name">
                  <Highlight search={"searchKey"}>
                    {selectedLine.deviceName}
                  </Highlight>
                </span>
              )}

              {isEdit && (
                <TextField
                  tabIndex={0}
                  className="editNumber"
                  inputRef={editDeviceRef}
                  style={{
                    height: "24px",
                    width: calWidth(),
                    border: "0px",
                    marginRight: "15px",
                  }}
                  onChange={onContactInput}
                  value={contactName}
                  onFocus={OnInputFocus}
                  inputProps={{
                    maxLength: CHARACTER_LIMIT,
                    tabIndex: 0,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {contactName.length >= 90 && (
                          <span>
                            {" "}
                            {`${contactName.length}/${CHARACTER_LIMIT}`}
                          </span>
                        )}
                        {isEdit && (
                          <IconButton
                            edge="end"
                            tabIndex={0}
                            onClick={ClearEditInput}
                            className="clearButton"
                            style={{ padding: 0 }}
                          >
                            <CloseIcon tabIndex={0} />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              {iconsAction && (
                <div className="Name-edit">
                  {!loading ? (
                    <>
                      <EditIcon {...iconsAction.pencil}></EditIcon>
                      <SaveIcon {...iconsAction.save}></SaveIcon>
                      <CancelIcon {...iconsAction.cancel}></CancelIcon>{" "}
                    </>
                  ) : (
                    <span className="spinner"></span>
                  )}
                </div>
              )}
            </div>
          )}
          {selectedLine.displayNumber !== "" && (
            <div className="phoneNumber" tabIndex={0}>
              <Highlight search={"searchKey"}>
                {selectedLine.displayNumber}
              </Highlight>
            </div>
          )}
          {primaryDeviceList.length > 0 && (
            <div className="primaryDevice" tabIndex={0}>
              <Highlight search={"searchKey"}>
                Primary Device: {primaryDeviceList[0].deviceName}
              </Highlight>
            </div>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          container
          justifyContent={{ xs: "flex-start", md: "end" }}
          alignItems="end"
          style={{ paddingRight: "16px", marginBottom: "-14px" }}
        >
          <div className="Line-actions">
            {selectedLine.categoryID === Category.unAssignedID && (
              <Button
                variant="text"
                size="medium"
                onClick={() => assignCB()}
                className="iconBtn "
                startIcon={<img src={AddIcon} alt="add icon" />}
                style={{ marginRight: "8px" }}
                tabIndex={0}
              >
                Add myself
              </Button>
            )}
            {isRemoveMyselfShow() && (
              <Button
                variant="text"
                size="medium"
                disableRipple
                className="iconBtn removeBtn"
                onClick={() => removeSelfCB()}
                startIcon={<img src={RemoveIcon} alt="remove icon" />}
                style={{ marginRight: "8px" }}
                tabIndex={0}
              >
                Remove myself
              </Button>
            )}
            {checkIsShareableLine && (
              <Button
                variant="text"
                size="medium"
                disableRipple
                className="iconBtn shareBtn"
                startIcon={<img src={ShareIcon} alt="share icon" />}
                onClick={shareLineCB}
                tabIndex={0}
              >
                Share this line
              </Button>
            )}
          </div>
        </Grid>

        <div className="Delve-container">
          {(selectedLine.categoryID === Category.assignedID ||
            selectedLine.categoryID === Category.unAssignedID) &&
            pairedLines.length > 0 && (
              <div>
                <div className="Delve-container-header header">
                  <img
                    src={peopleIcon}
                    alt={"help"}
                    width="24px"
                    height="24px"
                    className="header-icon"
                    tabIndex={0}
                  />
                  <div className="delve-header-text" tabIndex={0}>
                    Paired Wearable
                  </div>
                </div>
                {pairedLines.map((line: any, index: number) => {
                  return (
                    <NumberCard
                      type="delveDetails"
                      key={index}
                      deviceAvataar={WearableIcon}
                      deviceName={line.givenName}
                      displayNumber={line.msisdn}
                      id={line.msisdn}
                      granteeID={""}
                      lineType={selectedLine.lineType}
                      category="Wearable lines"
                      categoryID={Category.wearblesID}
                      searchKey={appService.returnMsisdnVariation(
                        searchInputValue && searchInputValue.length > 1
                          ? searchInputValue
                          : ""
                      )}
                      isPared={true}
                      unpairCB={unpairCB}
                      imsi={selectedLine.imsi}
                      isEditable={false}
                      isShareble={false}
                    />
                  );
                })}
              </div>
            )}
          <div className="Delve-container-header header">
            <img
              src={peopleIcon}
              alt={"help"}
              width="24px"
              height="24px"
              className="header-icon"
              tabIndex={0}
            />
            <div className="delve-header-text" tabIndex={0}>
              People using this line
            </div>
            <div>
              <Tooltip
                key={""}
                title={
                  <>
                    <div className="tooltipClose">
                      <img
                        src={iconClose}
                        alt={"close"}
                        width="14px"
                        height={"14px"}
                        onClick={() => handleCloseTooltip()}
                      />
                    </div>
                    {
                      "These are people who have access to this line in DIGITS. From here, people can be added or removed from this line."
                    }
                  </>
                }
                placement={"top"}
                open={selectedTooltip}
              >
                <span className="help-icon">
                  <img
                    src={helpIcon}
                    alt={
                      "help icon These are people who have access to this line in DIGITS. From here, people can be added or removed from this line."
                    }
                    width="16px"
                    height="16px"
                    tabIndex={0}
                    onClick={() => handleTooltip()}
                  />
                </span>
              </Tooltip>
            </div>
          </div>
          <div className="Delve-container-search">
            <Tooltip
              title={
                <React.Fragment>
                  {"Search by"}
                  <br /> {"number or line"}
                  <br />
                  {"name"}
                </React.Fragment>
              }
              placement="left"
            >
              <div className="searchMain" tabIndex={0}>
                <img
                  className="searchMainIcon"
                  src={SearchIcon}
                  tabIndex={0}
                  alt={"search"}
                  width="16px"
                  height="16px"
                />
                <input
                  aria-invalid="false"
                  tabIndex={0}
                  id="search"
                  placeholder="Search"
                  type="text"
                  className={`Rectangle searchbox ${
                    searchOnFocus ? "input-focus" : ""
                  }`}
                  value={searchInputValue}
                  onFocus={searchOnFocusAction}
                  onChange={onSearchInput}
                  disabled={loading ? true : false}
                />
                {SearchIcon && (
                  <img
                    className="searchClose"
                    src={SearchCloseIcon}
                    alt={"SearchCloseIcon"}
                    onClick={clearSearchInput}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        clearSearchInput();
                      }
                    }}
                    tabIndex={0}
                    width="16px"
                    height="16px"
                  />
                )}

                {/* 
              <TextField
                className={`Rectangle searchbox ${
                  searchOnFocus ? "input-focus" : ""
                }`}
                hiddenLabel
                id="search"
                size="small"
                value={searchInputValue}
                placeholder={"Search"}
                onFocus={searchOnFocusAction}
                onChange={onSearchInput}
                style={{ width: "301px", height: "40px" }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={SearchIcon}
                        alt={"search"}
                        width="16px"
                        height="16px"
                      />
                      {SearchIcon && (
                        <img
                          className="searchClose"
                          src={SearchCloseIcon}
                          alt={"SearchCloseIcon"}
                          onClick={clearSearchInput}
                          width="16px"
                          height="16px"
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
              /> */}
              </div>
            </Tooltip>
          </div>
          <div className="Delve-container-main">
            {!showSkeleton &&
            lineDelveDetails.userEmails &&
            lineDelveDetails.userEmails.length === 0 ? (
              errorMessage === "" ? (
                <div className="nodata">
                  {selectedLine.categoryID === Category.unAssignedID ? (
                    <p tabIndex={0}>
                      This line is currently not shared with anyone. To start
                      using the line on DIGITS,{" "}
                      <a
                        className="lineActions"
                        onClick={() => assignCB()}
                        ref={assignActionRef}
                        tabIndex={0}
                        onKeyDown={(event) =>
                          handleKeyUp(event, assignActionRef)
                        }
                      >
                        assign to yourself
                      </a>{" "} 
                      {selectedLine.lineType.toLowerCase() === 'virtual' ? <>
                      or you can also{" "}
                      <a
                        className="lineActions"
                        onClick={shareLineCB}
                        ref={shareLineRef}
                        tabIndex={0}
                        onKeyDown={(event) => handleKeyUp(event, shareLineRef)}
                      >
                        share this line
                      </a>{" "}
                      with others.</> : <>.</>}
                     
                    </p>
                  ) : (
                    <>
                      <img
                        src={Confused}
                        alt={"ConfusedIcon"}
                        width="32px"
                        height="32px"
                        tabIndex={0}
                      />
                      <span tabIndex={0}>
                        No results found; please try again.
                      </span>
                    </>
                  )}
                </div>
              ) : (
                <div className="nodata">
                  <span tabIndex={0}>
                    Unable to Fetch Lines. Please try again.
                  </span>
                </div>
              )
            ) : (
              lineDelveDetails.userEmails &&
              lineDelveDetails.userEmails.length > 0 &&
              !showSkeleton &&
              lineDelveDetails.userEmails.map(
                (user: userEmails, index: number) => {
                  return (
                    <NumberCard
                      type="delveDetails"
                      key={index}
                      deviceAvataar=""
                      deviceName={user.granteeEmail}
                      displayNumber=""
                      id={user.msisdn}
                      granteeID={user.grantee}
                      lineType={selectedLine.lineType}
                      category=""
                      categoryID={Category.emptyCategoryID}
                      searchKey={appService.returnMsisdnVariation(
                        searchInputValue && searchInputValue.length > 1
                          ? searchInputValue
                          : ""
                      )}
                      isRemovable={user.isRemovable}
                      deactivateCB={deactivateCB}
                      removeCB={onRemoveCB}
                      imsi={selectedLine.imsi}
                      isEditable={false}
                      isShareble={false}
                    />
                  );
                }
              )
            )}
            {showSkeleton && (
              <>
                <Skeleton
                  style={{
                    width: "100%",
                    height: "50px",
                  }}
                ></Skeleton>
                <Skeleton
                  style={{
                    width: "100%",
                    height: "50px",
                  }}
                ></Skeleton>
                <Skeleton
                  style={{
                    width: "100%",
                    height: "50px",
                  }}
                ></Skeleton>
                <Skeleton
                  style={{
                    width: "100%",
                    height: "50px",
                  }}
                ></Skeleton>
              </>
            )}
          </div>
        </div>
      </Grid>
    </React.Fragment>
  );
}
